<template>
  <div class="">

    <van-nav-bar
        title="找回直付密码"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

	<van-form @submit="onSubmit">
		<div class="group">
			<van-field
				v-model="authcode"
				name="sms"
				center
				clearable
				maxlength="4"
				:formatter="formatter" 
				label="短信验证码"
				placeholder="请输入短信验证码"
				:error-message="error_message"
				:rules="[{ required: true, message: '' }]"
			>
				<template #button>
					<van-button size="small" type="primary" color="#2176ff" native-type="button" :disabled="disabledCode"  @click="onSendAuthcode">{{count}}</van-button>
				</template>
			</van-field>
		</div>
		<div class="group">
			<van-field 
				v-model="onePwd" 
				name="onePwd" 
				type="password" 
				:formatter="formatter" 
				label="设置直付密码" 
				placeholder="请输入新密码(6位数字)" 
				maxlength="6" 
				:rules="[{ required: true,  message: '请输入新密码(6位数字)', pattern }]"
			/>
			<van-field 
				v-model="twopwd" 
				name="twopwd" 
				type="password" 
				:formatter="formatter" 
				label="确认密码" 
				placeholder="请输入新密码(6位数字)" 
				maxlength="6" 
				:rules="[
					{ required: true, message: '两次输入的密码不一致', validator:checkPasswords },
					{ required: true, message: '请输入新密码(6位数字)', pattern }]"
			/>
		</div>
		<div class="box-btn">
			<van-button  size="large" color="#2176ff" native-type="submit">确定</van-button>
		</div>
	</van-form>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {
		authcode: '',//验证码
		onePwd: '', //第一次密码
		twopwd: '',//第二次密码
		disabledCode: false,
		count: '获取验证码',
		pattern:/^\d{6}$/, //正则校验规则，6位数字
		error_message: ''
	  };
    },
    methods: {
		init(){
 			//倒计时
            let drugTime =  localStorage.getItem('drugTime') //提取倒计时缓存
			console.log('drugTime', drugTime)
			if(drugTime){//判断倒计时缓存并计算倒计时时间
				let timeDifference = 60  - parseInt((new Date().getTime() - drugTime) / 1000)
				console.log('timeDifference', parseInt((new Date().getTime() - drugTime) / 1000))
				if(timeDifference > 0){
					this.countdown(timeDifference);
					this.disabledCode = true;
				}else {
					localStorage.removeItem('drugTime');
				}
            }
			
            
		},
		onSendAuthcode(){
			if(this.disabledCode){ //是否在倒计时
                return;
            }
			this.$getRequestData('sendPwdAuthcode', {lysCstUserId: `${sessionStorage.getItem('lysCstUserId')}`})
            .then(result => {
                if(result.resultCode === '0000'){
					this.disabledCode = true;
					this.countdown(60);
                    console.log(result)
					this.error_message = `已发送验证码至***${result.bizData.subMobile}`
					// this.$toast({
					// 	message: `已发送验证码至***${result.bizData.subMobile}`,
					// 	duration: 3000
					// });
					
                }else{
					this.disabledCode = false;
				}
            });
		},
		// 验证码倒计时
        countdown (time) {
			if(!localStorage.getItem('drugTime')){
				let time = new Date().getTime()
				localStorage.setItem('drugTime', `${time}`);
            }
			
            this.disabledCode = true;
            let timeBar = setInterval(() => {
                this.count = `${time}s`;
                time--;
                //倒计时结束
                if(time == 0){
                    clearInterval(timeBar);
                    this.count = '重新获取'
                    this.disabledCode = false;
					localStorage.removeItem('drugTime');
                }
            }, 1000);
        },
		//过滤函数
		formatter(value) {
			return value.replace(/\D/g, ''); // 保留数字，去除非数字字符
		},
		checkPasswords(val) {
			if (val !== this.onePwd) {
				return false
			}
		},
		//提交函数
		onSubmit(values){
			console.log(values)
			let data = {
				lysCstUserId: `${sessionStorage.getItem('lysCstUserId')}`,
				'pwd': this.twopwd,
				'authcode': this.authcode
			}
			console.log(data)
			this.$getRequestData('updatePwdByAuthcode', data)
            .then(result => {
                if(result.resultCode === '0000'){

                    this.$dialog.alert({
                        title: '成功',
                        message: '设置新密码成功',
                        confirmButtonText: '返回首页',
                        theme: 'round-button'
                    }).then(() => {
                        this.$router.push({ path: '/index/homePage' });
                    });  

                }else{
					this.$toast({
						message: `${result.msg}`,
						duration: 3000
					});
				}
            });
		},

        onClickLeft(){
            history.go(-1);
        },
        onClickRight()
        {
             this.$router.push({ path: '/' })
        }, 
	},
    computed: {},
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.init()
	},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    // 生命周期 - 创建之前
    beforeCreate() {},
    // 生命周期 - 挂载之前
    beforeMount() {},
    // 生命周期 - 更新之前
    beforeUpdate() {},
    // 生命周期 - 更新之后
    updated() {},
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
    // 如果页面有keep-alive缓存功能，这个函数会触发
    activated() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.box-btn {
    margin-top: 80px;
    padding: 0 20%;
}
.group {
    margin: 20px 0;
}
.van-button--small {
    width: 80px;
}
</style>
